// custom definitions
(function ($, Drupal, window, document,mitos,undefined) {

  function initElements(){

    $(".path-search #views-exposed-form-search-page-1 input").attr('placeholder', 'Enter keywords');
    $("#views-exposed-form-search-page-2 input").attr('placeholder', 'Enter keywords');

  }

  function submitPagerPage() {

    let origQuerystring, newQuerystring,totalPages, enteredPageInt, enteredPageString, lastIndex = '';
    if($('.total-items').length) {
      totalPages = Number($('.total-items')[0].innerText);
    }
    origQuerystring = window.location.search;
    if(origQuerystring !== '') {
      if (origQuerystring.indexOf("page=") !== -1) {
        lastIndex = origQuerystring.lastIndexOf('=');
        newQuerystring = origQuerystring.substring(0, lastIndex + 1);
      }
      else {
        newQuerystring = origQuerystring + '&page=';
      }
    }
    else {
      newQuerystring = '?page='
    }

    if($(".page_jump").length) {
      $(".page_jump").each(function(index, element) {
        $(this).on("keydown", function(e) {
          let code = e.keyCode || e.which;
          if (code === 13 || code === 9) {
            e.preventDefault();
            enteredPageInt = Number($(this).val()) - 1;
            enteredPageString = enteredPageInt.toString();
            //if the input is within the number of available pages, direct to the correct search result page
            if(totalPages >= enteredPageInt+1) {
              window.location.href = newQuerystring + enteredPageString;
            }
            //if the input exceeds the number of available pages, don't allow it to work and tell the user
            else {
              alert('Please enter a number lower than the total number of pages')
            }
          }
        });
      });

    }
  }

  function removeExtraSortby() {
    if($('.sidebar .filter-content .form-item-sort-by').length) {
      $('.sidebar .filter-content .form-item-sort-by').remove();
    }

  }


  function storeFilterState() {
    // first eliminate duplicate ids from having two instances of the same exposed filter form
    if($('.resource-filter-header').length) {
      $('.resource-filter-header #filter-label').removeAttr('id');
      $('.resource-filter-header #filter-content').removeAttr('id');
    }
    //set state of filters into local storage
    $('#filter-label').on('click', function() {

      var isExpanded = "isExpanded";
      if($('#filter-content').hasClass('expanded')) {
        localStorage.removeItem("filterState");
      }
      else {
        localStorage.setItem("filterState", isExpanded);
      }
    })
  }

  function getFilterState() {
    let currentFilterState = localStorage.getItem('filterState');
    if(currentFilterState === 'isExpanded') {
      $('.filter-content').addClass('expanded');
    }
  }

  function initMobileNav(){
    // secondary menu
    var $top= $(".mobile-navigation");
    var $menus= $top.find("nav.navigation");
    $.each($menus,function(index,menu){
      var $header=$(menu).find("> h2");
      $header.click(function(){
        $(this).closest("nav.navigation").toggleClass("open");
        $top.toggleClass("level2-open")
      });
    });


    var resetmenus = function (){
      $top.removeClass("level2-open");
      $top.find("nav.navigation").removeClass("open");
    };

    $(".mobile-navigation-back").click(resetmenus);


    // mobile navigation expand/collapse
    $("#hamburger").on('click', function(e){
      resetmenus();
      $(".mobile-navigation").toggleClass('open');
      $(".mobile-navigation-outer").fadeIn(350);
      e.preventDefault();

    });

    $(".mobile-navigation-close").on('click', function(e){
      $(".mobile-navigation").toggleClass('open');
      $(".mobile-navigation-outer").fadeOut(350);
      e.preventDefault();
    });

    $(".mobile-navigation-outer").on('click', function(e){
      var clickover = $(e.target);
      //ignore clicks originating from the mobile menu block
      if (clickover.is(".mobile-navigation") || clickover.parents().is(".mobile-navigation")) {
        return;
      }
      $(".mobile-navigation").toggleClass('open');
      $(".mobile-navigation-outer").fadeOut(350);
      e.preventDefault();
    });

    // hide 'give' link in mobile menu
    var $items= $top.find(".menu--utility-menu .menu-item");
    $.each($items,function(index,item){
      var txt=$(item).find("a").text();

      if (txt && txt.toUpperCase() === "GIVE"){
        $(item).addClass("give");
      }
    });


  }

  var imageSlides=[];
  function imageSlide($par,url,w,h,alt,cred){
    this.$parent= $par;
    this.imageurl= url;
    this.width= w;
    this.height= h;
    this.alttext= alt;
    this.photocredit= cred;
  }

  function initHeroImages(){
    $(".field-collection-item--name-field-featured-images").each(function(index){
      var $el= $(this);
      var $img= $el.find(".field--name-field-image > img");
      var url, width, height, alttext, photocredit;
      var slide;
      if ($img){
        url= $img.attr('src');
        width= $img.attr('width');
        height= $img.attr('height');
        alttext= $img.attr('alt');
        photocredit= $el.find(".field--name-field-photo-credit").text();
        slide= new imageSlide($el,url,width,height,alttext,photocredit);
        imageSlides.push(slide);
      }
    });

    var item = imageSlides[Math.floor(Math.random()*imageSlides.length)]
    if (item){
      var $target= $(".feature-image-block");
      if ($target){
        $target.css("background-image", "url("+ item.imageurl+")");
        $target.attr("aria-label", item.alttext);
        if (item.photocredit) {
          $target = $(".feature-image-block .feature-photo-credit").text(item.photocredit);
        } else {
          $(".feature-image-block .feature-photo-credit").hide();
        }

      }
    }
  }

  function initParagraphs(){
    //small features with photos
    // add button when load more is enabled within a paragraph
    var p= $('.paragraph.paragraph--load-more--yes');
    $.each(p,function(index,par){
      var loadelem=$(par).find(".field--name-field-load-more-text");
      $( "<button class='paragraph-load-more-btn'>"+loadelem.text()+"</button>" ).insertAfter(loadelem);
    });
    $('.paragraph-load-more-btn').click(function(){
      $(this).closest(".paragraph").toggleClass("load-more-clicked");
    });

    // accordion expand/collapse
    $(".accordion .accordion-header").click(function(){
      // Toggle visibilty to work around bug in Firefox where height of accordion paragraph is not updated
      // when the accordion is collapsed on tabbed pages
      $(this).closest(".accordion").toggle();
      $(this).closest(".accordion").toggle();
      $(this).closest(".accordion").toggleClass("expanded");
    });


    //profile block
    p=$('.person-profile');
    $.each(p,function(index,par){
      var expand=$(par).find(".expand-btn");
      var collapse=$(par).find(".collapse-btn");
      var toggle= function(e){
        $(this).closest(".person-profile").toggleClass("expanded");
        e.preventDefault();
      };
      expand.click(toggle);
      collapse.click(toggle);
    });

    // Set cards to equal height as needed
    $(".field--name-field-cards > .field__item").matchHeight();
  }

  // Initialize carousels
  function initCarousels() {
    var carousels = '.field--name-field-gallery-item, .field--name-field-photo-card, .paragraph--type--photo-gallery .field--name-field-media';
    $(carousels).addClass(".owl-carousel");
    $(carousels).owlCarousel({
      items: 3,
      itemsCustom: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [980, 3],
      itemsTablet: [767, 1],
      itemsTabletSmall: false,
      itemsMobile: [479, 1],
      singleItem: false,
      itemsScaleUp: false,
      navigation: true,
      navigationText: false,
      slideSpeed: 200,
      paginationSpeed: 800,
      autoPlay: false,
      pagination: true
    });
    $(carousels).find(".owl-item > .field__item").matchHeight();
  }

  function initMediaGallery() {

    var $gallery = $('.paragraph--type--media-gallery .field--name-field-media');

    $gallery.on('init', function(event, slick){
      setCurrentSlideNumber(0);
    });
    $gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setCurrentSlideNumber(nextSlide);
    });
    $gallery.slick( {
      asNavFor: '.paragraph--type--media-gallery .carousel-control',
      infinite: false,
      speed: 200,
    });
    var $control = $('.paragraph--type--media-gallery .carousel-control');
    $control.slick( {
      slidesToShow: 6,
      focusOnSelect: true,
      infinite: false,
      speed: 200,
      asNavFor: '.paragraph--type--media-gallery .field--name-field-media',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 5,
            // centerMode: true
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 4,
            // centerMode: true
          }
        },
        {
          breakpoint: 460,
          settings: {
            slidesToShow: 3,
            // centerMode: true
          }
        }
      ]
    });

    function setCurrentSlideNumber(currentSlide) {
      $(".slide-position").text(currentSlide+1 + " of " + $(".carousel-control .field__item").length);
    }

    /* Fix the colorbox for the media gallery */

    if ($gallery.length > 0) {
      // $.colorbox.remove();
      var settings =
        {
          current: "{current} of {total}",
          fixed: true,
          maxHeight: "98%",
          maxWidth: "98%",
          next: "Next »",
          opacity: "0.85",
          previous: "« Prev",
          rel: 'gallery'
        };
      $('.colorbox').colorbox(settings);
      $('.video-embed-field-launch-modal').colorbox($.extend(settings, {'html': $('.video-embed-field-launch-modal').data('video-embed-field-modal'), rel:'gallery'}));
    }

  }

  // Make the Recent Resources / Recent News / Upcoming Events blocks the same height
  function initRecentResourcesBlock() {
    $(".recent-news-block > .view-content, .upcoming-events-block > .view-content, .recent-resources-block > .view-content").matchHeight();
  }

  // Make the home page start/study/solve the same height
  function initHomePage() {
    $(".start-study-solve-block .s-body").matchHeight();
    // home page mobile accordion expand/contract
    $("#home-1 h2, #home-2 h2").click(function(){
      $(this).closest(".block-views").toggleClass("expanded");
    });
    $("#home-3 .s-mobile-title").click(function(){
      $(this).parent().toggleClass("expanded");
    });
  }

  function fixup404Page() {
    if ($("form#form-404").length) {
      $("form#form-404").attr("action", "/search");
      $("main").css("background-color", "#f7f7f7");
      if (window.innerWidth > 767) {
        $("#featured").hide();
      }
    }

  }

  function removeInitialEllipsis() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let value = params.keyword; // "some_value"

    if($('.views-field-search-api-excerpt').length && (value !== '')) {
      $(".views-field-search-api-excerpt .field-content").each(function(index, element) {
        let str = $(this)[0].innerHTML;
        str = str.substring(1);
        $(this)[0].innerHTML = str;
      });
    }
  }

  mitos.init=function(){
    initHeroImages();
    initElements();
    initParagraphs();
    submitPagerPage();
    storeFilterState();
    getFilterState();
    initMobileNav();
    initCarousels();
    initMediaGallery();
    initHomePage();
    initRecentResourcesBlock();
    fixup404Page();
    removeExtraSortby();
    removeInitialEllipsis();
  };

  Drupal.behaviors.appInit = {
    // attach gets called after page loads, and after ajax calls
    attach: function (context, settings) {

      // ignoring context and settings parameter for this global application init, and using the body as the reference
      // restricting this function to run only one time via once() extension
      jQuery(once('app-init','body', context)).each(function(index) {
        mitos.init();
      });

      var sizeClasses = ['small','medium','large','xlarge'];
      enquire.register("screen and (max-width:639px)", {
        match: function() {
          $('.off-canvas-content').removeClass(sizeClasses).addClass('small');
        },
      });
      enquire.register("screen and (min-width:640px) and (max-width:1024px)", {
        match: function() {
          $('.off-canvas-content').removeClass(sizeClasses).addClass('medium');
        },
      });
      enquire.register("screen and (min-width:1025px) and (max-width:1200px)", {
        match: function() {
          $('.off-canvas-content').removeClass(sizeClasses).addClass('large');
        },
      });
      enquire.register("screen and (min-width:1201px)", {
        match: function() {
          $('.off-canvas-content').removeClass(sizeClasses).addClass('xlarge');
        },
      });
    }
  };
  // ===== Scroll to Top ====

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
      $('#return-to-top').fadeIn(200);    // Fade in the arrow
      $('#back-to-top').fadeIn(200);    // Fade in the button
    } else {
      $('#return-to-top').fadeOut(200);   // Else fade out the arrow
      $('#back-to-top').fadeOut(200);   // Else fade out the button
    }
  });
  $('#return-to-top').click(function() {      // When arrow is clicked
    window.scroll(0, 1);
    setTimeout(() => {
      $('body,html').animate({
        scrollTop : 0                       // Scroll to top of body
      }, 500);
    }, 10);
  });
  $('#back-to-top').click(function() {      // When arrow is clicked
    window.scroll(0, 1);
    setTimeout(() => {
      $('body,html').animate({
        scrollTop : 0                       // Scroll to top of body
      }, 500);
    }, 10);
  });


})(jQuery,Drupal,this, this.document,window.mitos = window.mitos || { });
